import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';
import type { PodFilterValue } from 'infrastructure/interfaces/ccm/pod';
import type { TOverviewDashboardFilter } from 'infrastructure/hooks/rpm/overview-dashboard';

export interface IRpmPodFilterProps {
  value?: PodFilterValue;
  updateFilter: (newFilter: Partial<TOverviewDashboardFilter>) => void;
}

export const RpmPodFilter: FC<IRpmPodFilterProps> = ({
  value,
  updateFilter,
}) => {
  const { t } = useTranslation();

  const options = [
    { value: 'all', label: t('labels.allPods') },
    { value: 'primary', label: t('labels.primaryPod') },
    { value: 'secondary', label: t('labels.secondaryPod') },
    { value: 'tertiary', label: t('labels.tertiaryPod') },
    { value: 'outside', label: t('labels.outsidePod') },
  ];

  return (
    <div data-cy="pod-filter-select" data-testid="pod-filter-select">
      <div className={s['select-label']}>
        <Select
          aria-label={t('labels.podFilterAriaLabel')}
          value={value ?? 'all'}
          options={options}
          className={s['select-root']}
          onChange={(v: string) => {
            updateFilter({
              podFilter: v === 'all' ? undefined : (v as PodFilterValue),
              page: undefined,
            });
          }}
          optionRender={(option) => (
            <span
              data-cy={`pod-filter-option-${option.value}`}
              data-testid={`pod-filter-option-${option.value}`}
            >
              {option.label}
            </span>
          )}
        />
      </div>
    </div>
  );
};
